import { combineReducers } from 'redux';

import {
  CouponManagementReducer,
  SubjectManageReducer,
  userReducer,
  loginReducer,
  UIStateReducer,
  SubjectReviewReducer,
  categoryReducer,
  PublisherReducer,
  fileExplorerReducer,
  TranscodingManagerReducer,
  LegalPageReducer,
  DeliveryReducer,
  StudentUpdatesReducer,
  StudentManagementReducer,
  LiveClassesReducer,
  BatchManagemntReducer,
  ClassroomAttendanceReducer,
} from 'src/store/reducers';

const rootReducer = combineReducers({
  selectedCategory: categoryReducer,
  userState: userReducer,
  loginState: loginReducer,
  subjectManage: SubjectManageReducer,
  couponsState: CouponManagementReducer,
  subjectReview: SubjectReviewReducer,
  publisher: PublisherReducer,
  uiState: UIStateReducer,
  fileExplorerReducer,
  transcodingManager: TranscodingManagerReducer,
  LegalPage: LegalPageReducer,
  deliveryState: DeliveryReducer,
  studentUpdates: StudentUpdatesReducer,
  studentManage: StudentManagementReducer,
  liveClassData: LiveClassesReducer,
  manageBatch: BatchManagemntReducer,
  classroomAttendance: ClassroomAttendanceReducer,
});

export default rootReducer;
